var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReqCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 100 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7151 74.2226V69.0155C59.4357 68.0966 63.877 62.1237 63.877 55.232C63.877 46.3492 57.2916 43.2862 48.562 41.2953V29.0432C51.7782 29.9621 53.616 32.1062 55.4538 34.7098L62.1924 29.809C59.4357 25.8271 55.6069 22.4578 48.7151 21.5389V16.9443H42.7423V21.2325C33.8595 21.9983 28.193 27.0523 28.193 35.0161C28.193 43.8988 35.3911 46.6555 43.0486 48.6465V61.8174C38.7604 61.0517 36.31 58.1418 33.8595 54.4662L26.9678 58.9076C30.0308 63.9615 34.6253 68.0966 42.7423 68.8623V74.0695H48.7151V74.2226ZM48.562 49.8717C52.6971 51.0969 54.5349 52.7816 54.5349 55.9977C54.5349 59.5202 52.5439 61.2048 48.562 61.8174V49.8717ZM37.5352 33.944C37.5352 31.1873 39.2198 28.8901 43.0486 28.4306V39.6106C39.373 38.5386 37.5352 37.1602 37.5352 33.944Z",
    fill: "#EF4D5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0197 83.5677C38.7586 84.6397 28.6506 81.5767 20.5337 74.9912C3.84025 61.6672 1.38984 37.0099 14.8671 20.4697C28.3443 3.92942 52.8484 1.32586 69.5418 14.8031C72.1454 16.7941 74.2895 19.2445 76.2804 21.848L68.0103 24.911L86.8478 40.6855L91.136 16.4878L82.4065 19.7039C79.9561 16.1815 77.0462 12.8121 73.5237 10.0554C54.2268 -5.56591 25.7408 -2.65605 10.1194 16.4878C-5.65509 35.7847 -2.59208 64.2707 16.5517 79.8921C24.6687 86.4775 34.6235 90 44.8846 90C46.4161 90 47.9476 89.8468 49.6323 89.6937C61.578 88.4685 72.2985 82.6488 79.9561 73.3066L75.2084 69.4778C68.6229 77.5948 59.2807 82.4956 49.0197 83.5677Z",
    fill: "#EF4D5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0762 42.1602L96.5255 63.6094",
    stroke: "#EF4D5C",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0762 63.6094L96.5255 42.1601",
    stroke: "#EF4D5C",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqCan);
export default __webpack_public_path__ + "static/media/reqCan.93a07c636a88dabf2f1e32963e025ede.svg";
export { ForwardRef as ReactComponent };